import { SIDEBAR_CONTENT_ID } from 'client/constants/editorIds'
import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { SettingsNestedMenuProps } from 'src/editor/layout/sidebar/settings/settings-nested-menu'
import { SettingsNestedMenuScreen } from 'src/editor/layout/sidebar/settings/settings-nested-menu/settings-nested-menu-screen'
import { FormSubentitySettingsMenuButton } from './form-subentity-settings-menu-button'

interface FormSubentitiesSettingsNestedMenuItemProps
  extends Pick<SettingsNestedMenuProps, 'isOpen' | 'onClose'> {
  title: string
  children: React.ReactNode
  icon: () => React.ReactNode
  onDelete?: (event: React.MouseEvent<SVGSVGElement>) => void
}

export const FormSubentitiesSettingsNestedMenuItem = ({
  title,
  children,
  icon,
  onDelete,
  isOpen: isOpenFromProps,
  onClose,
}: FormSubentitiesSettingsNestedMenuItemProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const onBack = () => {
    setIsOpen(false)
    onClose?.()
  }
  return (
    <>
      <FormSubentitySettingsMenuButton
        title={title}
        iconBefore={icon}
        onDelete={onDelete}
        onClick={() => setIsOpen(true)}
      />
      {(isOpenFromProps ?? isOpen) &&
        ReactDOM.createPortal(
          <SettingsNestedMenuScreen title={title} onClose={onBack}>
            {children}
          </SettingsNestedMenuScreen>,
          document.getElementById(SIDEBAR_CONTENT_ID) as HTMLElement,
        )}
    </>
  )
}
